import PropTypes from 'prop-types';
import React from 'react';

import { TEMPLATE_SELECTOR_SECTION_ID } from '@glass/web/modules/content/pages/contentIds';
import { EXTRA_SMALL_SPACING } from '@glass/web/modules/theme/spacing';

import TabTemplateChooser from '@glass/shared/components/ResumeBuilder/TemplateChooser/TabTemplateChooser';
import Section from '@glass/shared/components/Section/Section';

function TemplateChooserView({ title, subtitle }) {
  return (
    <Section
      disableCta
      isNoXPadding
      isAlternatingColor={false}
      outerSpacing={0}
      spacing={EXTRA_SMALL_SPACING}
      subtitle={subtitle}
      title={title}
      titleComponent="h1"
      type={TEMPLATE_SELECTOR_SECTION_ID}
    >
      <TabTemplateChooser contentResumeSlug="default" />
    </Section>
  );
}

TemplateChooserView.propTypes = {
  subtitle: PropTypes.node,
  title: PropTypes.node,
};

TemplateChooserView.defaultProps = {
  title: 'Get started by choosing a <b>template</b>',
  subtitle: 'You can always change and customize this&nbsp;later',
};

export default React.memo(TemplateChooserView);
